import { writable } from 'svelte/store';

//export const photos = writable([]);
export const userProfile = writable({});

export const currentPhoto = writable({});
